window.addEventListener('load', () => {
    document.querySelectorAll('a[href*="/pages/find-your-look"]').forEach(
        link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window['fp-virtual-mirror-add-on'].homepageTrigger();
            });
        }
    )
});
window['fp-virtual-mirror-add-on'] = {
    showUpdatedPopup: false,
    homepageTrigger: function() {
        window._fpEvent && window._fpEvent.push(["eventConversion",{value:"fp_vm_button_click"}]);
        return this.open({ source: 'find_your_look_link' });
    },
    /**
     * Opens the global virtual mirror, initialising it first if nothing has yet.
     *
     * @param {Object} [options]
     * @param {string[]} [options.handles] - Show only these frames, in this order. Unknown handles are skipped; none resolving shows every frame.
     * @param {string} [options.featured] - Handle to select first. Defaults to handles[0], else the first slide.
     * @param {string} [options.color] - Colour name to select on the featured frame.
     * @param {string} [options.source] - Passed through on the vm:open / vm:close event detail.
     * @returns {Promise<Object>} Resolves with the event detail once the modal is shown and the frame is set.
     */
    open: function(options) {
        var vm = this;
        if (!this._initialized) {
            this.showUpdatedPopup = true;
            this.init({
                addDialog: true,
                addModalOpener: false,
                dialogContainer: document.body,
                openerContainer: document.body,
                triggerSelector: '.button.button--tertiary.fp_button.hp_vm_button',
            });
        }
        return this.ready.then(function() {
            return vm.fpVirtualMirror.open(options || {});
        });
    },
    checkReady: function() {
        if (document.querySelector('.global-vm-popup') && document.querySelector('.all-vm-opener')) {
            this._readyCallbacks.resolve();
        }
    },
    // --- Helper Functions ---
    loadStyle: function(url) {
        return new Promise(function(resolve, reject) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.onload = function() {
                resolve(link);
            };
            link.onerror = function() {
                reject(new Error('Failed to load CSS: ' + url));
            };
            document.head.appendChild(link);
            let newStyle = document.createElement('style');
            newStyle.innerHTML = `
            .vm-pop-up-new-design .virtual-mirror-popup-modal__content {
                width: 100%;
                margin-top: 0 !important;
                margin-bottom: 0 !important;
                max-width: 462px !important;
                padding: 0 !important;
                padding-bottom: 16px !important;
            }
            
            .vm-pop-up-new-design .virtual-mirror-popup-modal__content-info>h2 {
                display: none !important;
            }
            
            .vm-pop-up-new-design .virtual-mirror-popup-modal__content-info>p {
                display: none !important;
            }
            
            .vm-pop-up-new-design .virtual-mirror-popup-modal__toggle {
                position: absolute !important;
                right: 16px !important;
                top: 16px !important;
                background: transparent;
                border: oldlace;
                padding: 0;
                width: 32px;
                height: 32px;
                background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='32' height='32' rx='16' fill='white'/%3E%3Cpath d='M8.29101 23.7088C8.34325 23.7611 8.40529 23.8026 8.47358 23.8309C8.54186 23.8592 8.61506 23.8738 8.68898 23.8738C8.7629 23.8738 8.8361 23.8592 8.90438 23.8309C8.97267 23.8026 9.03471 23.7611 9.08695 23.7088L16.0001 16.7957L22.916 23.7088C23.0216 23.8144 23.1647 23.8737 23.314 23.8737C23.4632 23.8737 23.6064 23.8144 23.7119 23.7088C23.8175 23.6033 23.8768 23.4601 23.8768 23.3109C23.8768 23.1616 23.8175 23.0184 23.7119 22.9129L16.796 15.9998L23.7091 9.08383C23.8147 8.97828 23.874 8.83513 23.874 8.68586C23.874 8.53659 23.8147 8.39344 23.7091 8.28789C23.6036 8.18234 23.4604 8.12305 23.3112 8.12305C23.1619 8.12305 23.0187 8.18234 22.9132 8.28789L16.0001 15.2038L9.08414 8.2907C8.97653 8.19855 8.83811 8.1504 8.69654 8.15587C8.55498 8.16133 8.42069 8.22002 8.32051 8.3202C8.22033 8.42038 8.16164 8.55467 8.15617 8.69624C8.15071 8.8378 8.19886 8.97622 8.29101 9.08383L15.2041 15.9998L8.29101 22.9157C8.18625 23.0211 8.12744 23.1637 8.12744 23.3123C8.12744 23.4609 8.18625 23.6034 8.29101 23.7088Z' fill='%23101010'/%3E%3C/svg%3E%0A");
                background-repeat: no-repeat;
                background-position: center;
                border-radius: 500px;
            }
            
            .vm-pop-up-new-design .virtual-mirror-popup-modal__toggle .icon {
                display: none !important;
            }
            
            .vm-pop-up-new-design div#fitmixContainerAll {
                height: calc(100vh - 230px);
                min-height: 470px !important;
                max-height: 520px !important;
            }
            
            .vm-pop-up-new-design .vm-contents {
                margin-top: 0 !important;
                margin-bottom: 0 !important;
                min-height: unset !important;
            }
            
            .vm-pop-up-new-design .virtual-mirror-popup-modal__content {
                height: 100%;
                max-height: 812px;
            }
            
            .vm-pop-up-new-design .vm-contents>.grid {
                flex-direction: column !important;
                margin-bottom: 0 !important;
                margin-left: 0 !important;
            }
            
            .vm-pop-up-new-design .vm-contents>.grid>div {
                width: 100% !important;
            }
            
            .vm-pop-up-new-design .vm-contents>.grid>div.grid__item:not([data-carousel-vm]) {
                padding-bottom: 0 !important;
                padding: 0 !important;
            }
            
            .vm-pop-up-new-design .vm-swiper-slide {
                height: 81px !important;
                width: 107px !important;
                align-items: center;
                justify-content: center;
                border: 1px solid #EBEBEB !important;
                background: #F6F6F6 !important;
            }
            
            .vm-pop-up-new-design div.virtual-mirror-popup-modal__content-info div.swiper.vm-swiper.grid__item[data-carousel-vm] {
                width: calc(100% - 16px) !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
                margin-left: 16px !important;
                padding-bottom: 40px !important;
                height: 123px !important;
                min-height: 123px !important;
                max-height: 123px !important;
                position: relative !important;
                bottom: 0 !important;
                margin-top: 16px !important; 
            }
            
            .vm-pop-up-new-design div.virtual-mirror-popup-modal__content-info div.swiper.vm-swiper.grid__item {
                margin: 0 !important;
                margin-left: 16px !important;
                position: relative !important;
                padding: 0 !important;
                padding-bottom: 40px !important;
                bottom: unset !important;
                padding-left: 0 !important;
            }
            
            .vm-pop-up-new-design div.virtual-mirror-popup-modal__content-info:has(.vm-swiper-slide--checked) iframe {
                height: 100% !important;
                overflow: hidden;
                border: 0px;
                max-height: 100% !important;
            }
            
            .vm-pop-up-new-design div.virtual-mirror-popup-modal__content-info {
                height: fit-content !important;
            }
            
            .vm-pop-up-new-design .vm-contents>.grid>div[data-carousel-vm] .swiper-pagination {
                margin-left: -16px;
                bottom: 8px !important;
            }
            
            .vm-pop-up-new-design .vm-contents .swiper-button-prev {
                top: unset !important;
                bottom: 0px !important;
                left: calc(50% - 170px) !important;
                transform: rotate(180deg);
                display: flex;
                align-items: center;
            }
            
            .vm-pop-up-new-design .vm-contents .swiper-button-next {
                top: unset !important;
                bottom: -2px !important;
                right: calc(50% - 135px) !important;
                display: flex;
                align-items: center;
            }
            .vm-pop-up-new-design .vm-contents .swiper-button-next:after{
              content: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='20' height='20' rx='10' fill='%23F6F6F6'/%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.617 5.61a.47.47 0 0 0-.132.334.5.5 0 0 0 .132.335l3.28 3.443-3.28 3.444a.485.485 0 0 0 0 .669.44.44 0 0 0 .319.138.44.44 0 0 0 .318-.139l3.598-3.777a.48.48 0 0 0 .132-.335.5.5 0 0 0-.132-.334L9.254 5.61a.45.45 0 0 0-.318-.139.43.43 0 0 0-.319.14' fill='%23101010'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M8.036 14.444V5h5.667v9.444z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
            }
            .vm-pop-up-new-design .vm-contents .swiper-button-prev:after{
              content: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='20' height='20' rx='10' fill='%23F6F6F6'/%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.617 5.61a.47.47 0 0 0-.132.334.5.5 0 0 0 .132.335l3.28 3.443-3.28 3.444a.485.485 0 0 0 0 .669.44.44 0 0 0 .319.138.44.44 0 0 0 .318-.139l3.598-3.777a.48.48 0 0 0 .132-.335.5.5 0 0 0-.132-.334L9.254 5.61a.45.45 0 0 0-.318-.139.43.43 0 0 0-.319.14' fill='%23101010'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M8.036 14.444V5h5.667v9.444z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
            }
            .vm-pop-up-new-design img.vm-swiper-slide--image {
                max-width: 200px;
                width: 100%;
                margin: auto;
                position: relative;
                height: auto;
                width: 89px !important;
                height: 34px !important;
                object-fit: cover !important;
                margin-bottom: 10px !important;
                margin-top: 0 !important;
            }
            
            h3.vm-swiper-slide--title {
                font-family: DIN Condensed;
                font-weight: 700;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.6px;
                text-align: center;
                vertical-align: middle;
                text-transform: uppercase;
            }
            
            .vm-pop-up-new-design .vm-contents .swiper-pagination-bullet {
                width: 8px !important;
                height: 8px !important;
                background: rgba(0, 0, 0, 0.2) !important;
            }
            
            .vm-pop-up-new-design .vm-contents .swiper-pagination-bullet-active {
                width: 8px !important;
                height: 8px !important;
                background: rgba(0, 0, 0, 1) !important;
            }
            
            .vm-pop-up-new-design .glasses-info-container {
                justify-content: space-between !important;
                display: flex !important;
                padding: 13px 16px !important;
                align-items: center !important;
            }
            
            .vm-pop-up-new-design .glasses-info-container .glass-shape {
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.6px;
                vertical-align: middle;
                text-transform: capitalize;
                color: rgba(16, 16, 16, 1);
            }
            
            .vm-pop-up-new-design .glasses-info-container button {
                border: 0;
                background: transparent;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.6px;
                text-align: right;
                vertical-align: middle;
                text-transform: capitalize;
                text-decoration: underline;
                text-decoration-style: solid;
                text-decoration-thickness: 1px;
                text-underline-offset: 2px;
                padding: 0;
                cursor: pointer;
            }
            
            .vm-pop-up-new-design .all-vm-hidden-link {
                max-width: 430px;
                width: calc(100vw - 32px);
                margin-left: 16px;
                padding: 0;
            }
            
            @media only screen and (min-width: 750px) {
                .vm-pop-up-new-design .virtual-mirror-popup-modal__content {
                    height: 722px;
                    max-height: calc(100vh - 5rem);
                    margin: auto;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    left: 50%;
                    right: unset;
                    bottom: unset;
                }
            }
            @media only screen and (max-width: 749px) {
                body .vm-pop-up-new-design div#fitmixContainerAll {
                height: calc(100dvh - 200px);
                min-height: unset !important;
                max-height: 530px !important;
            }
            }
            .vm-pop-up-new-design .vm-swiper-slide.selected{
                border-color: rgba(var(--color-button), var(--alpha-button-background)) !important;
                border-width: 2px !important;
                width: 105px !important;
                height: 79px !important;
            }
            .vm-pop-up-new-design .vm-swiper-slide.selected .vm-swiper-slide--checked{
                display: none !important;
            }
            .vm-pop-up-new-design .vm-contents .swiper-pagination-bullet {
              margin: 0 4px !important;
              cursor: pointer;
            }
            .vm-contents>.grid>a {
                width: calc(100% - 32px) !important;
                margin-left: 16px;
            }
      `
            document.head.appendChild(newStyle);
        });
    },
    loadScript: function(url) {
        return new Promise(function(resolve, reject) {
            var script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            script.onload = function() {
                resolve(script);
            };
            script.onerror = function() {
                reject(new Error('Failed to load script: ' + url));
            };
            document.head.appendChild(script);
        });
    },
    fetchPageContent: function() {
        return fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}pages/find-your-look`)
            .then(function(response) {
                return response.text();
            })
            .then(function(htmlString) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = htmlString;
                return tempDiv;
            });
    },

    // --- Public Methods ---
    /**
     * Fetches the modal dialog content and appends the <modal-dialog> element
     * to the provided container.
     *
     * @param {HTMLElement} container - The DOM element where the dialog will be inserted.
     */
    addDialog: function(container) {
        this.fetchPageContent()
            .then(function(parsedHtml) {
                var modalDialog = parsedHtml.querySelector('modal-dialog');
                if (modalDialog) {
                    modalDialog.classList.add('all-vm-popup');
                    modalDialog.classList.add('global-vm-popup');
                    
                    if (document.querySelector('.global-vm-popup')) {
                        window['fp-virtual-mirror-add-on'].checkReady();
                        return;
                    }
                    container.appendChild(modalDialog);
                    const fp = window['fp-virtual-mirror-add-on'].fpVirtualMirror;
                    fp.allSlides = Array.from(modalDialog.querySelectorAll('.vm-swiper-slide'));
                    fp.watchDialog(modalDialog);
                    const fieldset = modalDialog.querySelector('[data-vm-swatches]');
                    fieldset && fieldset.addEventListener('change', function(event) {
                        const slide = modalDialog.querySelector('.vm-swiper-slide.selected');
                        slide && fp.selectFrame(slide, event.target.dataset.vmColor);
                    });
                    if (window['fp-virtual-mirror-add-on'].showUpdatedPopup) {

                        modalDialog.classList.add('vm-pop-up-new-design');
                        modalDialog.querySelector('.all-vm-hidden-link') && (modalDialog.querySelector('.all-vm-hidden-link').style.display = 'flex');
                        modalDialog.querySelector('.vm-contents > .grid > div a:not(.all-vm-hidden-link)') && (modalDialog.querySelector('.vm-contents > .grid > div a:not(.all-vm-hidden-link)').style.display = 'none');
                        let slide = modalDialog.querySelector('.swiper-slide.vm-swiper-slide.selected');

                        if (slide) {
                            fp.selectFrame(slide);
                            let modalResetButton = modalDialog.querySelector('.reset-vm');
                            if (modalResetButton) {
                                modalResetButton.addEventListener('click', function() {

                                    let slideSKU = modalDialog.querySelector('.swiper-slide.vm-swiper-slide.selected').dataset.sku;
                                    window['fp-virtual-mirror-add-on'].fpVirtualMirror.setFrame(slideSKU);
                                    window._fitmixInstanceAll.startVto('live');
                                    window._fitmixInstanceAll.addCss("[vto-advanced-watermark],[data-testid=watermark]{ display: none !important; }");
                                })
                            }
                        }

                    }
                    window['fp-virtual-mirror-add-on'].checkReady();
                } else {
                    console.warn('Modal dialog element not found');
                }
            })
            .catch(function(error) {
                console.error('Error fetching modal dialog:', error);
            });
    },

    /**
     * Fetches the modal opener content and appends the <modal-opener> element
     * to the provided container. Also initializes the inline virtual mirror script.
     *
     * @param {HTMLElement} container - The DOM element where the opener will be inserted.
     * @param {boolean} visible - Whether the modal opener should be visible.
     * @param {string|null} triggerSelector - (Optional) A CSS selector for an element that should trigger the opener.
     */
    addModalOpener: function(container, visible, triggerSelector) {
        this.fetchPageContent()
            .then((parsedHtml) => {
                var modalOpener = parsedHtml.querySelector('modal-opener');
                if (modalOpener) {
                    if (!visible) {
                        modalOpener.style.display = 'none';
                    }
                    modalOpener.classList.add('all-vm-opener');
                    container.appendChild(modalOpener);
                    this.initVirtualMirrorInlineScript();
                    if (triggerSelector) {
                        // Delegated: PLP filtering replaces the grid, and the triggers with it.
                        document.addEventListener('click', (event) => {
                            if (!event.target.closest(triggerSelector)) return;
                            event.preventDefault();
                            window['fp-virtual-mirror-add-on'].open({ source: 'plp_tile' });
                        });
                    }
                    this.checkReady();
                } else {
                    console.warn('Modal opener element not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching modal opener:', error);
            });
    },

    /**
     * Initializes the inline virtual mirror script. This method sets up event listeners
     * on the launch button, and triggers actions based on URL parameters.
     */
    initVirtualMirrorInlineScript: function() {
        const launchBtns = document.querySelectorAll('[data-fitmix-color].all-vm-opener button');

        launchBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                const fp = window['fp-virtual-mirror-add-on'].fpVirtualMirror;
                const popup = document.querySelector('.global-vm-popup');
                const slide = popup && (popup.querySelector('.vm-swiper-slide.selected') || popup.querySelector('.vm-swiper-slide'));
                if (!slide) return;
                const checked = popup.querySelector('[data-vm-product]:checked');
                fp.setFitmix(fp.selectFrame(slide, checked && checked.dataset.vmColor));
                window._utils.waitForCondition(() => window.Swiper && typeof window.Swiper === 'function' && document.querySelector('.global-vm-popup [data-carousel-vm]'), (carousel) => {
                    carousel && fp.vmSwiper();
                }, 50, 1e4);
            });
        });

        // Auto-trigger based on URL parameters.
        if (window.location.pathname.includes('products') && window.location.search.includes('show_vm')) {
            const button = document.querySelector('[data-fitmix-color] button');
            button && button.click();
        } else if ((window.location.pathname.includes('pages/find-your-look') ||
                window.location.pathname.includes('/collections')) &&
            window.location.search.includes('show_vm')) {
            window._utils.waitForCondition(() => window.Swiper && typeof window.Swiper === 'function', (swiperLoaded) => {
                const button = document.querySelector('[data-fitmix-color] button');
                swiperLoaded && button && button.click();
            }, 50, 1e4);
        }
    },

    /**
     * Loads the required CSS and external script assets.
     *
     * @returns {Promise} A promise that resolves when all assets are loaded.
     */
    loadAssets: function() {
        return Promise.all([
            this.loadStyle('/cdn/shop/t/690/assets/virtual-mirror.css'),
            this.loadScript('//vto-advanced-integration-api.fittingbox.com/index.js')
        ]);
    },

    /**
     * Initializes the virtual mirror add-on. Accepts an options object to control whether
     * the modal dialog and modal opener should be added, as well as their container elements.
     * Additionally, you can pass a triggerSelector to attach a click event that fires the modal opener.
     *
     * @param {Object} options - Configuration options.
     * @param {boolean} [options.addDialog=true] - Whether to add the modal dialog.
     * @param {boolean} [options.addModalOpener=true] - Whether the modal opener should be visible.
     * @param {HTMLElement} [options.dialogContainer=document.body] - Container for the modal dialog.
     * @param {HTMLElement} [options.openerContainer=document.body] - Container for the modal opener.
     * @param {string|null} [options.triggerSelector=null] - A CSS selector for an element that triggers the modal opener.
     */
    init: function(options) {
        if (this._initialized) return;
        this._initialized = true;
        options = options || {};
        const {
            addDialog = true,
                addModalOpener = true,
                dialogContainer = document.body,
                openerContainer = document.body,
                triggerSelector = null
        } = options;

        this.loadAssets().then(() => {
            // Add dialog to dialogContainer.
            if (addDialog) {
                this.addDialog(dialogContainer);
            }
            // Always add modal opener to openerContainer; hide it if addModalOpener is false.
            this.addModalOpener(openerContainer, addModalOpener, triggerSelector);
            window._fpEvent=window._fpEvent||[];
            window._fpEvent.push(["eventConversion",{value:"vm_popup_init"}]);
        }).catch((error) => {
            console.error('Error loading assets: ', error);
            this._readyCallbacks.reject(error);
        });
    },

    // --- Virtual Mirror Functionality ---
    fpVirtualMirror: {
        populateSwatches: function(btn) {
            const modalFieldset = document.querySelector('[data-vm-plp-fieldset]');
            const vmProductHandle = btn.dataset.plpVmHandle;
            const vmProductColor = btn.dataset.fitmixColor;
            const vmProductData = JSON.parse(document.querySelector('[data-plp-vm-json]').textContent);
            const currentProduct = vmProductData.find(item => item.handle === vmProductHandle);
            const currentProductColors = currentProduct.colors.split(' | ').filter(n => n);
            const currentProductSkus = currentProduct.skus.split(' | ').filter(n => n);
            if (modalFieldset.getAttribute('data-vm-plp-fieldset') === (vmProductHandle + ' | ' + vmProductColor)) {
                return;
            }
            modalFieldset.setAttribute('data-vm-plp-fieldset', (vmProductHandle + ' | ' + vmProductColor));
            modalFieldset.innerHTML = '';
            currentProductColors.forEach((color, i) => {
                var swatchEl = document.querySelector('label[title="' + color + '"]');
                var swatchStyle = swatchEl ? swatchEl.getAttribute('style') : '';
                const colorSwatch = `
          <input 
            type="radio" id="plp-vm-swatch--${i}"
            name="virtual-mirror__input--btn"
            aria-label="${color}"
            value="${currentProductSkus[i]}"
            data-fitmix-sku="${currentProductSkus[i]}" 
            data-vm-color="${color}"
            ${vmProductColor === color ? 'checked' : ''}
          >
          <label 
            for="plp-vm-swatch--${i}"
            class="virtual-mirror__input--label label--swatch"
            style="${swatchStyle}"> 
            ${color}
          </label>`;
                modalFieldset.innerHTML += colorSwatch;
            });
        },
        populateShopBtn: function(btn) {
            let slide = document.querySelector('.swiper-slide.vm-swiper-slide.selected')
            let slideTitle = slide.getAttribute('data-vm-product-title');
            let slideURL = slide.getAttribute('data-vm-product-url');
            let slidePrice = slide.getAttribute('data-price');
            let slideShape = slide.getAttribute('data-shape');

            document.querySelectorAll('[data-product-shop]').forEach(function(e) {
                e.innerHTML = window.lookT('look.general.shop_product', { title: slideTitle });
            });
            document.querySelectorAll('[data-product-shop]').forEach(function(e) {
                e.setAttribute('href', slideURL);
            });
        },
        setFitmix: function(fitmixSKU) {
            const fp = this;
            document.querySelector('.virtual-mirror-popup-modal.all-vm-popup #fitmixContainer') && (document.querySelector('.virtual-mirror-popup-modal.all-vm-popup #fitmixContainer').id = 'fitmixContainerAll');
            fp.widgetReady = false;
            window._fitmixInstanceAll = FitMix.createWidget('fitmixContainerAll', {
                apiKey: 'tIMYszmvsul1ftaVCOiBtFwg2WKs1ZKrGrxtCwQ3',
                css: "[vto-advanced-watermark],[data-testid=watermark]{ display: none !important; }"
            }, function() {
                fp.setFrame(fitmixSKU);
                window._fitmixInstanceAll.startVto('live');
                window._fitmixInstanceAll.addCss("[vto-advanced-watermark],[data-testid=watermark]{ display: none !important; }");
                window['fp-virtual-mirror-add-on'].showUpdatedPopup && (window._fitmixInstanceAll.addCss("#vtoAdvLive > vto-advanced-bottom-right-action-button-ui > button { display: none !important; }"));
                fp.widgetReady = true;
            });
        },
        setFrame: function(sku) {
            window._fitmixInstanceAll.setFrame(sku);
        },
        /**
         * Selects a frame in the global pop-up: slide state, shape, Shop button, that frame's
         * swatches and colour label, and the FittingBox frame when the widget exists.
         *
         * @param {HTMLElement} slide - The .vm-swiper-slide to select.
         * @param {string} [colour] - Colour name to check; falls back to the slide's SKU, then the frame's first swatch.
         * @returns {string} The FittingBox SKU now selected.
         */
        selectFrame: function(slide, colour) {
            const popup = slide.closest('.global-vm-popup');
            const current = popup.querySelector('.vm-swiper-slide.selected');
            current && current.classList.remove('selected');
            slide.classList.add('selected');

            const slideShape = slide.getAttribute('data-shape');
            const shapeContainer = popup.querySelector('.shape');
            slideShape && shapeContainer && (shapeContainer.innerHTML = slideShape);

            const slideTitle = slide.getAttribute('data-vm-product-title');
            const slideURL = slide.getAttribute('data-vm-product-url');
            document.querySelectorAll('[data-product-shop]').forEach(function(e) {
                e.innerHTML = window.lookT('look.general.shop_product', { title: slideTitle });
                e.setAttribute('href', slideURL);
            });

            const swatches = Array.from(popup.querySelectorAll('[data-vm-product]')).filter(function(swatch) {
                swatch.disabled = swatch.dataset.vmProduct !== slide.dataset.vmProductHandle;
                return !swatch.disabled;
            });
            const wanted = colour && colour.toLowerCase();
            const swatch = (wanted && swatches.find(s => s.dataset.vmColor.toLowerCase() === wanted)) ||
                swatches.find(s => s.dataset.fitmixSku === slide.dataset.sku) ||
                swatches[0];
            swatch && (swatch.checked = true);
            const fieldset = popup.querySelector('.vm-form__input');
            fieldset && fieldset.classList.toggle('hide', swatches.length < 2);
            const selectedColorSpan = popup.querySelector('.vm-selected-color');
            selectedColorSpan && swatch && (selectedColorSpan.innerHTML = swatch.dataset.vmColor);

            const sku = swatch ? swatch.dataset.fitmixSku : slide.dataset.sku;
            window._fitmixInstanceAll && this.setFrame(sku);
            return sku;
        },
        /**
         * Resolves a product handle to a slide: by data-vm-product-handle, else by the product's
         * title against data-vm-product-title (which has the type words stripped, e.g. "NO.13").
         */
        findSlide: function(handle) {
            const slides = this.allSlides;
            const slide = slides.find(s => s.dataset.vmProductHandle === handle);
            if (slide) return Promise.resolve(slide);
            return fetch('/products/' + encodeURIComponent(handle) + '.js')
                .then(response => response.ok ? response.json() : null)
                .then(function(product) {
                    if (!product) return null;
                    const title = product.title.toUpperCase();
                    return slides.find(s => s.dataset.vmProductTitle.toUpperCase() === title) ||
                        slides.find(s => title.indexOf(s.dataset.vmProductTitle.toUpperCase() + ' ') === 0) ||
                        null;
                })
                .catch(() => null);
        },
        showSlides: function(slides) {
            const wrapper = document.querySelector('.global-vm-popup [data-carousel-vm] .swiper-wrapper');
            wrapper.replaceChildren.apply(wrapper, slides);
            this.filtered = slides !== this.allSlides;
            this.swiper && this.swiper.update();
        },
        open: function(options) {
            const fp = this;
            const handles = options.handles || [];
            const featured = options.featured || handles[0];
            return Promise.all(handles.concat(featured ? [featured] : []).map(h => fp.findSlide(h))).then(function(found) {
                let featuredSlide = featured ? found.pop() : null;
                const slides = found.filter((s, i) => s && found.indexOf(s) === i);
                const shown = slides.length ? slides : fp.allSlides;
                fp.showSlides(shown);
                if (shown.indexOf(featuredSlide) < 0) featuredSlide = shown[0];
                fp.selectFrame(featuredSlide, options.color);
                fp.source = options.source;
                const popup = document.querySelector('.global-vm-popup');
                document.querySelector('.all-vm-opener button').click();
                return new Promise(function(resolve) {
                    window._utils.waitForCondition(() => popup.hasAttribute('open') && fp.widgetReady, function() {
                        resolve(fp.eventDetail);
                    }, 50, 1e4);
                });
            });
        },
        /**
         * Fires vm:open / vm:close for every way the pop-up opens and closes, and restores
         * the full slide list after a filtered open.
         */
        watchDialog: function(popup) {
            const fp = this;
            new MutationObserver(function() {
                const isOpen = popup.hasAttribute('open');
                if (isOpen === !!fp.isOpen) return;
                fp.isOpen = isOpen;
                if (isOpen) {
                    const slide = popup.querySelector('.vm-swiper-slide.selected');
                    const swatch = popup.querySelector('[data-vm-product]:checked');
                    fp.eventDetail = {
                        handles: fp.filtered ? Array.from(popup.querySelectorAll('.vm-swiper-slide')).map(s => s.dataset.vmProductHandle) : null,
                        featured: slide ? slide.dataset.vmProductHandle : null,
                        color: swatch ? swatch.dataset.vmColor : null,
                        source: fp.source || null
                    };
                    fp.source = null;
                    window.dispatchEvent(new CustomEvent('vm:open', { detail: fp.eventDetail }));
                } else {
                    fp.filtered && fp.showSlides(fp.allSlides);
                    window.dispatchEvent(new CustomEvent('vm:close', { detail: fp.eventDetail }));
                }
            }).observe(popup, { attributes: true, attributeFilter: ['open'] });
        },
        vmSwiper: function() {
            const fp = this;
            const carousel = document.querySelector('.global-vm-popup [data-carousel-vm]');
            if (!fp.swiper) {
                if (window['fp-virtual-mirror-add-on'].showUpdatedPopup) {
                    fp.swiper = new Swiper(carousel, {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                          var out = ''
                          for (var i = 1; i < total+1; i++) {
                            if (i == current) {
                              out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex='+i+' role="button" aria-label="Go to slide '+i+1+'"></span>';
                            }
                            else {
                              out = out + '<span class="swiper-pagination-bullet" tabindex='+i+' role="button" aria-label="Go to slide '+i+1+'"></span>';
                            }
                          };
                          return out;
                        },
                      },
                      navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                    });
                } else {
                    fp.swiper = new Swiper(carousel, {
                        slidesPerView: 2,
                        grid: {
                            rows: 1
                        },
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        pagination: {
                            el: ".global-vm-popup .swiper-pagination",
                            clickable: true
                        },
                        watchOverflow: true,
                        spaceBetween: 12,
                        breakpoints: {
                            480: {
                                slidesPerView: 3,
                                grid: {
                                    rows: 2
                                },
                                spaceBetween: 30
                            }
                        }
                    });
                }
                carousel.addEventListener('click', function(event) {
                    const slide = event.target.closest('.vm-swiper-slide');
                    slide && fp.selectFrame(slide);
                });
            }
            fp.swiper.update();
            const index = Array.from(fp.swiper.slides).indexOf(carousel.querySelector('.vm-swiper-slide.selected'));
            fp.swiper.slideTo(Math.max(index, 0), 0);
        }
    }
};
window['fp-virtual-mirror-add-on'].ready = new Promise(function(resolve, reject) {
    window['fp-virtual-mirror-add-on']._readyCallbacks = { resolve: resolve, reject: reject };
});
window['fp-virtual-mirror-add-on'].ready.catch(function() {});
// Keyboard bridge for the theme's href-less virtual-mirror triggers (.fp_button).
// They are anchors styled as buttons; the VM library only binds click, so Enter
// and Space have to be forwarded to a click when the trigger has focus.
document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target.closest('a.fp_button');
    if (!trigger || trigger.getAttribute('href')) return;
    event.preventDefault();
    trigger.click();
});
document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-tryon]');
    if (!button) return;
    event.preventDefault();
    const swatch = button.closest('[data-product-card]')?.querySelector('[data-swatch-input]:checked');
    window['fp-virtual-mirror-add-on']
        .open({ featured: button.dataset.cardTryon, color: swatch ? swatch.value : '', source: 'plp_card' })
        .catch(() => {});
});
